export const Screens = {
  ENTER_AADHAAR_CARD: 'enter_aadhaar_card',
  ENTER_AADHAAR_OTP: 'enter_aadhaar_otp',
  SCAN_FINGERPRINT: 'scan_fingerprint',
  HOME_SCREEN: 'home_screen',
  BBPS_LOAD_INITIAL: 'bbps_load_initial',
  CUSTOMER_ONBORD: 'customer_onboard',
  MOBILE_RECHARGE: 'mobile_recharge',
  ADD_CUSTOMER: 'add_customer',
  RECHARGE_BILL_PAYMENTS: 'bill_payment',
  MOBILE_BILL_PAYMENTS: 'Mobile_Bill_Payment',
  TRANSACTION_DETAILS: 'transaction_details',
  TRANSACTION_ERROR_DETAILS: 'transaction_error',
  VIEW_DETAILS: 'view_details',
  AGENT_TRANSACTION_HISTORY: 'agent_transaction_history',
  LOAD_INITIALS: 'load_initials',
  CASH_W_OR_D_Screen: 'cash_withdraw_or_deposit_screen',
  BALANCE_ENQUIRY: 'balance_enquiry',
  FUND_TRANSFER: 'fund_transfer',
  MINI_STATEMENT: 'mini_statement',
  TRANSACTION_ENQUIRY: 'transaction_enquiry',
  STATEMENT_LIST: 'statement_list',
  REVIEW_CASH_WITHDRAWAL: 'review_cash_withdrawal',
  AGENT_AUTH_SCREEN: 'agent_auth_screen',
  CASH_WITHDRAWAL_STATUS: 'cash_withdrawal_status',
  REVIEW_FUND_TRANSFER: 'review_fund_transfer',
  ENTER_CUSTOMER_MOBILE: 'enter_customer_mobile',
  ENTER_CUSTOMER_MOBILE_OTP: 'enter_customer_mobile_otp',
  ENTER_CUSTOMER_AADHAAR: 'enter_customer_aadhaar',
  ENTER_CUSTOMER_AADHAAR_OTP: 'enter_customer_aadhaar_otp',
  VERIFY_OTP: 'verify_otp',
  REGISTER_USER: 'register_user',
  SCAN_QR: 'scan_qr_code',

  //Money transfer screens.
  DOMESTIC_MONEY_TRANSFER_LOGIN: 'domestic_money_transfer_login',
  DOMESTIC_MONEY_TRANSFER_OTP: 'domestic_money_transfer_otp',
  ENTER_CUSTOMER_DETAILS: 'enter_customer_details',
  ENTER_BENEFICIARY_DETAILS: 'enter-beneficiary-details',
  TRANSACTION_SUCCESS_SCREEN: 'transaction-success-screen',
  SPLIT_TRANSACTION_SUCCESS_SCREEN: 'split-transaction-success-screen',
  BENEFICIARY_LIST_SCREEN: 'beneficiary-list-screen',
  NO_BENEFICIARY_FOUND: 'no_beneficiary_found',
  DELETE_BENELIST: 'delete_benelist',
  TRANSFER_FUND: 'transfer_fund-screen',
  DOMESTIC_MONEY_TRANSFER_HOME_SCREEN: 'money_transfer_home_screen',
  DOMESTIC_MONEY_TRANSACTIONS_SCREEN: 'domestic_money_transactions_screen',
  SEARCH_IFSC: 'search-ifsc',
  SELECT_LOGIN_TYPE_SCREEN: 'select-login-type',
  SPLITTED_TNX_LIST: 'splitted_tnx_list',

  //Refund Flow
  REFUND_LOGIN: 'refund_login',
  REFUND_CODE: 'enter_refund_code',
  PENDING_REFUNDS: 'pending_refunds',
  REFUND_DETAILS: 'refund_details',
  BC_AGENT_OTP: 'bc_agent_otp',
  REFUND_STATUS: 'refund_status',
  REGENERATE_REFUND_CODE: 'regenerate_refund_code',
  BENEFICIARY_LOADER: 'beneficiary_loader',
  REFUND_CODE_REGENERATION_STATUS: 'refund_code_status',
  DATA_MISMATCH_SCREEN: 'data_mismatch_screen',
  UTR_REFUND_DETAIL_SCREEN: 'UTR_REFUND_DETAIL_SCREEN',
  UTR_REF_CUSTOMER_VALIDATION_SCREEN: 'UTR_REF_CUSTOMER_VALIDATION_SCREEN',

  //BBPS
  BBPS_HOME_SCREEN: 'bbps_home_screen',
  BbpsBillerScreen: 'bbps_biller_screen',
  BbpsBillDetailsScreen: 'bbps_bill_details_screen',
  PaymentProcessingScreen: 'payment_processing_screen',
  TRANSACTION_DETAILS_SCREEN: 'transaction_details_screen',
  SeeAllOrderHistory: 'SeeAllOrderHistory',
  SeeAllFavourite: 'SeeAllFavourite',
  //BBPS 
  // BBPS_HOME_SCREEN: 'bbps_home_screen',
}

export const linking = {
  prefixes: ['https://sit-atsweb.test.jiobank.in/aeps', 'https://sit-atsweb.test.jiobank.in', 'localhost://'],
  // prefixes: ['https://localhost.com', 'localhost://'],
  // prefixes: [
  //   'aepsapp://', // Replace 'localhost://' 
  //   'https://sit-atsweb.test.jiobank.in', 
  //   // You can remove 'https://localhost.com' and 'localhost://' once deployed
  // ],
  config: {
    screens: {
      [Screens.ENTER_AADHAAR_CARD]: '/auth/enter_aadhaar_card',
      [Screens.ENTER_AADHAAR_OTP]: '/auth/enter_aadhaar_otp',
      [Screens.SCAN_FINGERPRINT]: '/auth/scan_fingerprint',
      [Screens.HOME_SCREEN]: '/home_screen',
      [Screens.BBPS_HOME_SCREEN]: '/bbps_home_screen',
      [Screens.BBPS_LOAD_INITIAL]: '/bbps_load_initial',
      [Screens.MOBILE_RECHARGE]: '/mobile_recharge',
      [Screens.CUSTOMER_ONBORD]: '/customer_onboard',
      [Screens.ADD_CUSTOMER]: '/add_customer',
      // [Screens.ADD_CUSTOMER]: '/add_customer',
      [Screens.VERIFY_OTP]: '/verify_otp',
      [Screens.REGISTER_USER]: '/register_user',
      [Screens.RECHARGE_BILL_PAYMENTS]: '/bill_payment',
      [Screens.MOBILE_BILL_PAYMENTS]: '/Mobile_Bill_Payment',
      [Screens.PaymentProcessingScreen]: '/payment_processing_screen',
      [Screens.TRANSACTION_DETAILS_SCREEN]: '/transaction_details_screen',
      [Screens.SeeAllFavourite]: '/SeeAllFavourite',
      [Screens.SeeAllOrderHistory]: '/SeeAllOrderHistory',
      [Screens.TRANSACTION_DETAILS]: '/transaction_details',
      // [Screens.TRANSACTION_DETAILS]: 'pg-redirect/jpb/bbps/order-status',
      [Screens.TRANSACTION_ERROR_DETAILS]: '/transaction_error',
      [Screens.VIEW_DETAILS]: '/view_details',
      [Screens.AGENT_TRANSACTION_HISTORY]: '/agent_transaction_history',
      [Screens.LOAD_INITIALS]: 'load_initials',
      [Screens.CASH_W_OR_D_Screen]: '/home_screen/cash_withdraw_or_deposit_screen',
      [Screens.BALANCE_ENQUIRY]: '/home_screen/balance_enquiry',
      [Screens.FUND_TRANSFER]: '/home_screen/fund_transfer',
      [Screens.MINI_STATEMENT]: '/home_screen/mini_statement',
      [Screens.TRANSACTION_ENQUIRY]: '/home_screen/transaction_enquiry',
      [Screens.STATEMENT_LIST]: '/home_screen/statement_list',
      [Screens.REVIEW_CASH_WITHDRAWAL]: '/home_screen/review_cash_withdrawal',
      [Screens.AGENT_AUTH_SCREEN]: '/home_screen/agent_auth_screen',
      [Screens.CASH_WITHDRAWAL_STATUS]: '/home_screen/cash_withdrawal_status',
      [Screens.REVIEW_FUND_TRANSFER]: '/home_screen/review_fund_transfer',
      [Screens.ENTER_CUSTOMER_MOBILE]: '/home_screen/enter_customer_mobile',
      [Screens.ENTER_CUSTOMER_MOBILE_OTP]: '/home_screen/enter_customer_mobile_otp',
      [Screens.ENTER_CUSTOMER_AADHAAR]: '/home_screen/enter_customer_aadhaar',
      [Screens.ENTER_CUSTOMER_AADHAAR_OTP]: '/home_screen/enter_customer_aadhaar_otp',
      [Screens.DOMESTIC_MONEY_TRANSFER_LOGIN]: '/domestic_money_transfer/login',
      [Screens.DOMESTIC_MONEY_TRANSFER_OTP]: '/domestic_money_transfer/otp',
      [Screens.ENTER_CUSTOMER_DETAILS]: '/domestic_money_transfer/enter_customer_details',
      [Screens.ENTER_BENEFICIARY_DETAILS]: '/domestic_money_transfer/beneficiary_details',
      [Screens.TRANSACTION_SUCCESS_SCREEN]: '/domestic_money_transfer/transaction-success-screen',
      [Screens.BENEFICIARY_LIST_SCREEN]: '/domestic_money_transfer/beneficiary-list-screen',
      [Screens.NO_BENEFICIARY_FOUND]: '/domestic_money_transfer/no-beneficiary-found',
      [Screens.TRANSFER_FUND]: '/domestic_money_transfer/transfer-fund',
      [Screens.SEARCH_IFSC]: '/domestic_money_transfer/search-ifsc-screen',
      [Screens.REFUND_LOGIN]: '/refund/login',
      [Screens.REFUND_CODE]: '/refund/enter_refund_code',
      [Screens.PENDING_REFUNDS]: '/refund/pending_refunds',
      [Screens.REFUND_DETAILS]: '/refund/refund_details',
      [Screens.BC_AGENT_OTP]: '/refund/bc_agent_otp',
      [Screens.REFUND_STATUS]: '/refund/status',
      [Screens.REGENERATE_REFUND_CODE]: '/refund/regenerate-refund-code',
      [Screens.BENEFICIARY_LOADER]: '/refund/beneficiary-loader',
      [Screens.REFUND_CODE_REGENERATION_STATUS]: '/refund/refund-code-regeneration-status',
      [Screens.DATA_MISMATCH_SCREEN]: '/refund/incorrect-data-entered',
      [Screens.UTR_REFUND_DETAIL_SCREEN]: '/refund/UTR_REFUND_DETAIL_SCREEN',
      [Screens.UTR_REF_CUSTOMER_VALIDATION_SCREEN]: '/refund/UTR_REF_CUSTOMER_VALIDATION_SCREEN',
      [Screens.SCAN_QR]: '/home_screen/scan_qr_code',
      [Screens.DELETE_BENELIST]: '/domestic_money_transfer/delete_benelist',
    },
  },
}
